import { passwordValidationRules, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

var CONDITIONS = [
    {
        title: 'password-indicator.require.min-max-length',
        id: 'min-max-length',
        validator: passwordValidationRules['min-max-length'](),
    },
    {
        title: 'password-indicator.require.1-digit',
        id: 'number',
        validator: passwordValidationRules.number(),
    },
    {
        title: 'password-indicator.require.1-symbol',
        id: 'symbol',
        validator: passwordValidationRules.symbol(),
    },
    {
        title: 'password-indicator.require.1-uppercase',
        id: 'uppercase',
        validator: passwordValidationRules.uppercase(),
    },
    {
        title: 'password-indicator.require.1-lowercase',
        id: 'lowercase',
        validator: passwordValidationRules.lowercase(),
    },
];
var PasswordIndicatorComponent = /** @class */ (function (_super) {
    __extends(PasswordIndicatorComponent, _super);
    function PasswordIndicatorComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PasswordIndicatorComponent.prototype, "currentStatus", {
        get: function () {
            var _this = this;
            return this.filteredConditions.map(function (_a) {
                var id = _a.id, params = _a.params, validator = _a.validator, title = _a.title;
                return {
                    title: title,
                    params: params,
                    id: id,
                    isValid: validator(_this.value || ''),
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PasswordIndicatorComponent.prototype, "filteredConditions", {
        get: function () {
            var _this = this;
            return CONDITIONS.map(function (condition) {
                var match = _this.conditions.find(function (cond) {
                    if (typeof cond === 'object') {
                        return cond.name === condition.id;
                    }
                    return cond === condition.id;
                });
                if (match) {
                    if (typeof match === 'object' &&
                        match.name === 'min-max-length') {
                        var min = match.value.min;
                        var max = match.value.max;
                        return __assign(__assign({}, condition), { title: 'password-indicator.require.min-max-length.with-params', params: { min: min, max: max }, validator: passwordValidationRules['min-max-length']({
                                min: min,
                                max: max,
                            }) });
                    }
                    return __assign(__assign({}, condition), { params: {} });
                }
                return null;
            }).filter(Boolean);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PasswordIndicatorComponent.prototype, "isAllValid", {
        get: function () {
            return this.currentStatus.every(function (_a) {
                var isValid = _a.isValid;
                return isValid;
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], PasswordIndicatorComponent.prototype, "value", void 0);
    __decorate([
        Prop({
            type: Array,
            default: CONDITIONS.map(function (_a) {
                var id = _a.id;
                return id;
            }),
            required: false,
            validator: function (property) {
                var available = CONDITIONS.map(function (_a) {
                    var id = _a.id;
                    return id;
                });
                return property.every(function (condition) {
                    if (typeof condition === 'object') {
                        return available.includes(condition.name);
                    }
                    return available.includes(condition);
                });
            },
        }),
        __metadata("design:type", Array)
    ], PasswordIndicatorComponent.prototype, "conditions", void 0);
    PasswordIndicatorComponent = __decorate([
        Component({
            name: 'ui-password-indicator',
        })
    ], PasswordIndicatorComponent);
    return PasswordIndicatorComponent;
}(Mixins(MagicConfigMixin)));

export default PasswordIndicatorComponent;
